import React from 'react';
import { Box, Button, FlexBox, Grid, Logo, Typography } from '@kis-technologies/kis-ui';
import packageJSON from '../../../package.json';
import { useStyles } from './ActionContainer.styled';
import { ActionContainerTypes } from './ActionContainer.types';

const ActionContainer = (props: ActionContainerTypes) => {
  const { buttonAction, buttonDisabled, children, header, isLoading } = props;

  const classes = useStyles();

  return (
    <Grid container className={classes.gridContainer}>
      <Grid item md={12} xl={6} lg={6} className={classes.gridItem}>
        {/* Logo */}
        <FlexBox className={classes.logoBox}>
          <Logo height={80} />
        </FlexBox>
        {/* Header */}
        <FlexBox className={classes.headerBox}>
          <Typography className={classes.header}>{header}</Typography>
        </FlexBox>
        {/* Content */}
        <FlexBox className={classes.contentBox}>{children}</FlexBox>
        {/* Footer */}
        <FlexBox className={classes.footerBox}>
          <Box>
            <Typography className={classes.infoText}>
              Version: {packageJSON.version}
              <br />
              ©KIS Technologies
            </Typography>
          </Box>
          {buttonAction ? (
            <Button
              customSize="small"
              disabled={buttonDisabled}
              isLoading={isLoading}
              onClick={buttonAction}
              width={150}
            >
              Continue
            </Button>
          ) : (
            <></>
          )}
        </FlexBox>
      </Grid>
    </Grid>
  );
};

export default ActionContainer;
